import { base } from "viem/chains";
import { BaseBondkitTokenFactoryContractAddress, BaseMainnetRpcUrl } from "./constants.js";
const baseMainnetConfig = {
    chain: base,
    rpcUrl: BaseMainnetRpcUrl,
    factoryAddress: BaseBondkitTokenFactoryContractAddress,
    apiEndpoint: "https://api.b3.fun/bondkit-tokens",
    chartApiEndpoint: "https://bondkit-chart-api.b3.fun",
};
export const getConfig = (chainId, rpcUrl) => {
    if (chainId === base.id) {
        return {
            ...baseMainnetConfig,
            rpcUrl: rpcUrl || BaseMainnetRpcUrl,
        };
    }
    throw new Error(`Unsupported chainId: ${chainId}. This SDK is configured for Base (Chain ID: ${base.id}) only.`);
};
